import React, { useState } from 'react'
import { Container, Row, Col, Card, Button, Collapse, Accordion, Breadcrumb } from 'react-bootstrap';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { GET_COUNTY_CITIES, GET_CITY_SUBURBS, GET_COUNTY_SUBURBS } from '../api/constants';
import { Link } from 'react-router-dom';
import redArrow from '../assets/images/red-arrow.svg'
import useCities from '../hooks/useCities'
import useCounties from '../hooks/useCounties';
import useStats from '../hooks/useStats';

function ExploreResultLocations() {
  const { cities } = useCities();
  const [view, setView] = useState("tabs");
  const [activeTab, setActiveTab] = useState("county");
  const [selectedCounty, setSelectedCounty] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [city, setCity] = useState(null);
  const [county, setCounty] = useState(null);


  const { counties } = useCounties();
  const [county_cities, setCities] = useState([])
  const [city_suburbs, setCitySuburbs] = useState([])
    const [county_suburbs, setCountySuburbs] = useState([])



  const fetchCities = async (countyId) => {
    try {
      const response = await fetch(`${GET_COUNTY_CITIES}/${countyId}`);
      const data = await response.json();

      // ✅ tolerate different API shapes
      if (Array.isArray(data?.data.cities)) {
        setCities(data.data.cities);
      } else if (Array.isArray(data)) {
        setCities(data);
      } else {
        setCities([]);
      }
    } catch (err) {
      console.error("Error fetching cities:");
    }
  };

  const fetchSuburbs = async (cityId) => {
    try {
      const response = await fetch(`${GET_COUNTY_SUBURBS}/${cityId}`);
      const data = await response.json();

      // ✅ tolerate different API shapes
      if (Array.isArray(data?.data)) {
        setCountySuburbs(data.data);
      } else if (Array.isArray(data)) {
        setCountySuburbs(data);
      } else {
        setCountySuburbs([]);
      }
    } catch (err) {
      console.error("Error fetching cities:");
    }
  };
  const countiesDummy = [
    {
      id: 52,
      county_name: "Nairobi",
      created_at: "2026-01-01T08:00:00.000Z",
    },
    {
      id: 28,
      county_name: "Mombasa",
      created_at: "2026-01-01T08:00:00.000Z",
    },
  ];
  const citiesDummy = [
    {
      id: 1,
      county_id: 52,
      city_name: "Nairobi",
      created_at: "2026-01-06T07:15:50.942Z",
    },
    {
      id: 2,
      county_id: 52,
      city_name: "Westlands",
      created_at: "2026-01-06T07:16:10.112Z",
    },
    {
      id: 3,
      county_id: 28,
      city_name: "Mombasa Island",
      created_at: "2026-01-06T07:17:00.500Z",
    },
  ];



  const suburbsDummy = [
    {
      id: 11,
      city_id: 1,
      suburb_name: "CBD",
      created_at: "2026-01-06T08:00:00.000Z",
    },
    {
      id: 12,
      city_id: 2,
      suburb_name: "Parklands",
      created_at: "2026-01-06T08:01:00.000Z",
    },
  ];
  const filteredCities = county
    ? counties.filter(c => c.county_id === county.id)
    : [];

  const filteredSuburbs = city
    ? suburbsDummy.filter(s => s.city_id === city.id)
    : [];




  //were here
  const { markets, apartment_cities, new_listings } = useStats()
  console.log("appsrt", apartment_cities)

  const [expandedCards, setExpandedCards] = useState({
    markets: false,
    apartments: false,
    resources: false,
    listings: false
  });

  const toggleCard = (card) => {
    setExpandedCards(prev => ({
      ...prev,
      [card]: !prev[card]
    }));
  };


  const resources = ['Mortgage Calculator', 'Market Trends', 'Property Values', 'School Ratings'];

  return (
    <>
      <div className="explore-result-locations common-padding">
        <Container>
          <div className="common-header">
            <h2>
              Explore Result by Locations
            </h2>
            <p>
              Discover properties across top locations, curated to match your lifestyle and investment needs.
            </p>
          </div>
          <Row className="g-4 mb-3 mt-lg-5">
            <Col md={6} lg={3}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>Popular Real Estate Markets</Card.Title>
                  <>
                    {markets.map((market, idx) => {
                      // First item (index 0) rendered normally
                      if (idx === 0) {
                        return (
                          <Link key={idx} to={`/search?suburb=${market.split(',')[0]}`} title={market}>
                            {market} real estate
                          </Link>
                        );
                      }

                      // Other items (index >= 1) inside Collapse
                      return (
                        <Collapse key={idx} in={expandedCards.markets}>
                          <div className="mb-3">
                            <Link key={idx} to={`/search?suburb=${market.split(',')[0]}`} title={market}>
                              {market} real estate
                            </Link>
                          </div>
                        </Collapse>
                      );
                    })}
                  </>
                  <Button
                    variant="link"
                    className="text-danger p-0 text-decoration-none d-flex align-items-center"
                    onClick={() => toggleCard('markets')}
                  >
                    {expandedCards.markets ? 'See Less' : 'See More'}
                    <img src={redArrow} alt="" />
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>Popular Apartment Cities</Card.Title>

                  <>
                    {apartment_cities.map((city, idx) => {
                      // First city (index 0) outside Collapse
                      if (idx === 0) {
                        return (
                          <Link key={idx} to={`/search?city=${city.split(',')[0]}&category=Apartment`} title={city}>
                            {city} apartments
                          </Link>
                        );
                      }

                      // Other cities (index >= 1) inside Collapse
                      return (
                        <Collapse key={idx} in={expandedCards.apartments}>
                          <div className="mb-3">
                            <Link key={idx} to={`/search?city=${city.split(',')[0]}`} title={city}>
                              {city} apartments
                            </Link>
                          </div>
                        </Collapse>
                      );
                    })}
                  </>
                  <Button
                    variant="link"
                    className="text-danger p-0 text-decoration-none d-flex align-items-center"
                    onClick={() => toggleCard('apartments')}
                  >
                    {expandedCards.apartments ? 'See Less' : 'See More'}
                    <img src={redArrow} alt="" />
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>Popular Resources</Card.Title>
                  <Link to={'#'} title={''}>
                    Home Buying Guide
                  </Link>
                  <Collapse in={expandedCards.resources}>
                    <div className="mb-3">
                      {resources.map((resource, idx) => (
                        <Link key={idx} to="#" title={''}>
                          {resource}
                        </Link>
                      ))}
                    </div>
                  </Collapse>
                  <Button
                    variant="link"
                    className="text-danger p-0 text-decoration-none d-flex align-items-center"
                    onClick={() => toggleCard('resources')}
                  >
                    {expandedCards.resources ? 'See Less' : 'See More'}
                    <img src={redArrow} alt="" />
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>New Listings By County</Card.Title>
                  <>
                    {new_listings.map((county, idx) => {
                      // First item outside Collapse
                      if (idx === 0) {
                        return (
                          <Link key={idx} to={`/search?county=${county}`} title={county}>
                            {county} new listings
                          </Link>
                        );
                      }

                      // Other items inside Collapse
                      return (
                        <Collapse key={idx} in={expandedCards.listings}>
                          <div className="mb-3">
                            <Link key={idx} to={`/search?county=${county}`} title={county}>
                              {county} new listings
                            </Link>
                          </div>
                        </Collapse>
                      );
                    })}
                  </>
                  <Button
                    variant="link"
                    className="text-danger p-0 text-decoration-none d-flex align-items-center"
                    onClick={() => toggleCard('listings')}
                  >
                    {expandedCards.listings ? 'See Less' : 'See More'}
                    <img src={redArrow} alt="" />
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Accordion defaultActiveKey="0" >
            {/* <Accordion.Item eventKey="0">
              <Accordion.Header>
                <h5>Search For Homes By City</h5>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  {cities.map((column, colIndex) => (
                    <Col key={colIndex} sm={6} md={4} xl={3} xxl={2}>
                      {column.map((city, cityIndex) => (
                        <Link
                          key={cityIndex}
                          to={`/search?city=${city}&category=Home`} title={''}>
                          {city}
                        </Link>
                      ))}
                    </Col>
                  ))}
                </Row>
              </Accordion.Body>
            </Accordion.Item> */}
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <h5>Search For Properties By County</h5>
              </Accordion.Header>
              <Accordion.Body>

                <>
                  {/* BREADCRUMBS */}
                  {county && (
                    <Breadcrumb className="mb-0 custom-breadcrumb">
                      {/* <Breadcrumb.Item
                        onClick={() => {
                          setCounty(null);
                          setCity(null);
                        }}
                      >
                        Home
                      </Breadcrumb.Item> */}

                      {county && (
                        <Breadcrumb.Item  onClick={() => {
                          setCounty(null);
                          setCity(null);
                        }}>
                          {county.county_name} County
                        </Breadcrumb.Item>
                      )}

                      {city && <Breadcrumb.Item active>{city.city_name}</Breadcrumb.Item>}
                    </Breadcrumb>

                  )}

                  {/* COUNTIES */}
                  {!county && (
                    <Row>
                      {counties.map(item => (
                        <Col key={item.id} sm={6} md={4} xl={3}>


                          <Link onClick={() => {
                            setCounty(item);
                            fetchSuburbs(item.id);
                          }}>
                            {item.county_name}
                          </Link>
                        </Col>


                      ))}
                    </Row>
                  )}

                  {/* CITIES */}
                  {/* {county && !city && (
                    <Row>
                      {county_cities.map(item => (
                        <Col key={item.id} sm={6} md={4}>
                      
                          <Link onClick={() => {
                           setCity(item);
                            fetchSuburbs(item.id);
                          }}>
                            {item.city_name}
                          </Link>
                        </Col>
                      ))}
                    </Row>
                  )} */}

                  {/* SUBURBS */}
                  {county && (
                    <Row>
                      {county_suburbs.map(item => (
                        <Col key={item.id} sm={6} md={4}>
                          <Link
                            className="location-item"
                            to={`/search?&suburb=${item.suburb_name}`}
                          >
                            {item.suburb_name}
                          </Link>
                        </Col>
                      ))}
                    </Row>
                  )}
                </>
              </Accordion.Body>
            </Accordion.Item>

            {/* <Accordion.Item eventKey="1">
              <Accordion.Header>
                <h5>Search For Homes By County Current</h5>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  {counties.map((column, colIndex) => (
                    <Col key={colIndex} sm={6} md={4} xl={3} xxl={2}>
                      {column.map((county, stateIndex) => (
                        <Link
                          key={stateIndex}
                          to={`/search?county=${county}&category=Home`} title={''}>
                          {county}
                        </Link>
                      ))}
                    </Col>
                  ))}
                </Row>
              </Accordion.Body>
            </Accordion.Item> */}
            {/* <Accordion.Item eventKey="2">
              <Accordion.Header>
                <h5>Search For Apartments By City</h5>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  {cities.map((column, colIndex) => (
                    <Col key={colIndex} sm={6} md={4} xl={3} xxl={2}>
                      {column.map((city, cityIndex) => (
                        <Link
                          key={cityIndex}
                          to={`/search?city=${city.split(',')[0]}&category=Apartment`}>
                          {city}
                        </Link>
                      ))}
                    </Col>
                  ))}
                </Row>
              </Accordion.Body>
            </Accordion.Item> */}
            {/* <Accordion.Item eventKey="3">
              <Accordion.Header>
                <h5>Search For The Newest Homes For Sale</h5>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  {cities.map((column, colIndex) => (
                    <Col key={colIndex} sm={6} md={4} xl={3} xxl={2}>
                      {column.map((city, cityIndex) => (
                        <Link key={cityIndex} to={`/search?city=${city.split(',')[0]}&category=Home&listing_type=sale`} title={city}>
                          {city} New Homes
                        </Link>
                      ))}
                    </Col>
                  ))}

                </Row>
              </Accordion.Body>
            </Accordion.Item> */}
          </Accordion>
        </Container>
      </div>
    </>
  )
}
export default ExploreResultLocations